import React, { useState } from 'react'

const AddedToFav = ({ color = '#fff', hoverColor = '#bbfa33', imgClass = '' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={imgClass}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      viewBox="0 0 21.293 17.924"
    >
      <g data-name="Group 1180">
        <path
          data-name="favorite-svgrepo-com (3)"
          d="M1 7.736C1 3.877 4.069 3 5.823 3c2.193 0 3.947 1.754 4.823 3.069C11.523 4.754 13.277 3 15.47 3c1.754 0 4.823.877 4.823 4.736 0 5.788-9.646 11.05-9.646 11.05S1 13.523 1 7.736z"
          transform="translate(0 -2)"
          style={{ fill: 'none', stroke: isHovered ? hoverColor : color, strokeWidth: '2px' }}
        />
        <path
          data-name="tick-svgrepo-com (1)"
          d="m272.954 319.912-1.112-1.112-4.751 4.749-1.978-1.977-1.113 1.113 3.09 3.091z"
          transform="translate(-256.861 -313.395)"
          style={{ fill: isHovered ? hoverColor : color }}
        />
      </g>
    </svg>
  )
}

export default AddedToFav
